import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    logged: false,
    token: null,
    userId: null,
    user: null,
  },
  reducers: {
    setLogin(state, action) {
      const { token, user } = action.payload;
      state.logged = true;
      state.token = token;
      state.userId = user.id;
      state.user = user;
    },
    setLogout(state) {
      state.logged = false;
      state.token = null;
      state.userId = null;
      state.user = null;
    },
    setNewUser(state, action) {
      state.user = action.payload;
    },
  },
});

export const { setLogin, setLogout, setNewUser } = authSlice.actions;

export default authSlice.reducer;
